<script>
    import Token from "./Token"

    export default {
        name: "UserInit",
        mixins: [Token],
        data() {
            return {

            }
        },
        methods: {
            checkUserAuth() {
                console.log(123, this.appToken);
            }
        },
        beforeMount() {
            this.checkUserAuth();
        }
    }
</script>